import FormattedMessage from 'I18n/components/FormattedMessage';
import { useSignupEmbedder } from 'signup-embedder/hooks/useSignupEmbedder';
import styled from 'styled-components';
import { useIsFramedCentredStep } from '../hooks/useIsFramedCentredStep';
import { Data } from 'signup-constants/signupData/Data';
import { useSignupData } from '../signup-data/useSignupData';
import FormControl from '../views-components/FormControl';
import NextButtonWrapper from '../views-components/NextButtonWrapper';
import { BaseView } from '../views/BaseView';
import { Step } from 'signup-constants/Step';
import { useView } from '../views/useView';
import CodeVerificationInput from './CodeVerificationInput';
import ResendCodeFooter from './ResendCodeFooter';
import { TrackWhen, useExperiment } from '../experiments/useExperiment';
import { ExperimentKeys } from '../experiments/ExperimentKeys';
import GoToMailButton from '../step-check-your-email/GoToMailButton';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const StyledFormControl = styled(FormControl).withConfig({
  displayName: "CodeVerificationView__StyledFormControl",
  componentId: "ed8s79-0"
})(["min-height:7.5rem;label{font-weight:400;font-size:16px;}"]);
const StyledStrongEmailAddress = styled.strong.withConfig({
  displayName: "CodeVerificationView__StyledStrongEmailAddress",
  componentId: "ed8s79-1"
})(["overflow-wrap:anywhere;"]);
export const CodeVerificationEmailHelper = () => {
  const {
    data: email
  } = useSignupData(Data.Email);
  const stepKey = Step.CodeVerification;
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx(FormattedMessage, {
      message: `views.${stepKey}.bodyText`
    }), /*#__PURE__*/_jsx("p", {
      children: /*#__PURE__*/_jsx(StyledStrongEmailAddress, {
        "data-key": "email-verification",
        children: email
      })
    })]
  });
};
export const CodeVerificationView = () => {
  const stepKey = Step.CodeVerification;
  const dataKey = Data.CodeVerification;
  const {
    data: email
  } = useSignupData(Data.Email);
  const {
    isActive: isEmbedded
  } = useSignupEmbedder();
  const {
    isInvalid,
    isValid
  } = useSignupData(dataKey);
  const {
    submit
  } = useView({
    stepKey
  });
  const {
    isFramedCentredStep
  } = useIsFramedCentredStep();
  const {
    isAssignedToVariant: isACQ0143Variant
  } = useExperiment(ExperimentKeys.ACQ0143, TrackWhen.never);
  return /*#__PURE__*/_jsxs(BaseView, {
    navMarker: `${stepKey}_SUCCEEDED`,
    stepKey: stepKey,
    children: [!isACQ0143Variant() && /*#__PURE__*/_jsx(CodeVerificationEmailHelper, {}), /*#__PURE__*/_jsxs("form", {
      action: "blue-button-in-all-fields-ios",
      onSubmit: submit,
      children: [/*#__PURE__*/_jsx(StyledFormControl, {
        dataKey: dataKey,
        children: /*#__PURE__*/_jsx("div", {
          "data-selenium": stepKey,
          children: /*#__PURE__*/_jsx(CodeVerificationInput, {
            "data-selenium": stepKey,
            isInvalid: isInvalid,
            isValid: isValid
          })
        })
      }), isACQ0143Variant() && /*#__PURE__*/_jsx(GoToMailButton, {
        email: email
      }), /*#__PURE__*/_jsx(NextButtonWrapper, {
        enabled: isValid,
        label: "button.next",
        onClick: submit
      })]
    }), !isEmbedded && /*#__PURE__*/_jsx(ResendCodeFooter, {
      className: isFramedCentredStep ? 'm-top-6' : 'm-top-3'
    })]
  });
};